// sectionTypeContext.tsx
import React, { createContext, useContext, useMemo } from 'react';

type SectionType = 'FRONTOFFICE' | 'BACKOFFICE';

interface SectionTypeContextType {
  sectionType: SectionType;
}

const SectionTypeContext = createContext<SectionTypeContextType | undefined>(
  undefined,
);

interface IProps {
  children: React.ReactNode;
  sectionType: SectionType;
}

export function SectionTypeProvider(props: IProps) {
  const value = useMemo(() => {
    return { sectionType: props.sectionType };
  }, [props.sectionType]);

  return (
    <SectionTypeContext.Provider value={value}>
      {props.children}
    </SectionTypeContext.Provider>
  );
}

/**
 * Hook che permette di sapere dal context se ci si trova all'interno della
 * configurazione di una sezione (frontoffice) o di una sezione dati (backoffice).
 *
 * Utilizzato in admin.
 */
export const useSectionType = (): SectionTypeContextType => {
  const context = useContext(SectionTypeContext);
  if (!context) {
    throw new Error('useSectionType must be used within a SectionTypeProvider');
  }
  return context;
};
